import { createQueryKeys, inferQueryKeys } from '@lukemorales/query-key-factory';

import { $httpRootApi, useQuery, UseQueryOptions } from '@core/http-client';
import { getQueriesAsSearch } from '@shared/utils/common';

import { SocietyMembersListPayload, SocietyMembersListResponse } from './societyMembersApi.types';

export const societyMembersQueryKeys = createQueryKeys('societyMembers', {
  all: null,
  list: (payload: SocietyMembersListPayload) => ({
    queryKey: [payload.query],
    queryFn: async ({ signal }) =>
      (
        await $httpRootApi.get<SocietyMembersListResponse>(`/society/members${getQueriesAsSearch(payload.query)}`, {
          signal,
        })
      ).data,
  }),
});

export type SocietyMembersQueryKeys = inferQueryKeys<typeof societyMembersQueryKeys>;

export const useSocietyMembersListQuery = (
  payload: SocietyMembersListPayload,
  opts?: UseQueryOptions<SocietyMembersListResponse>
) =>
  useQuery<SocietyMembersQueryKeys['list']['queryKey'], SocietyMembersListResponse>({
    ...societyMembersQueryKeys.list(payload),
    keepPreviousData: true,
    ...opts,
  });
